import { Client } from '../../../features/bot/modules/bot-crm/store';

export interface ChatStateModel {
  messages: ChatMessage[];
  options: MessagesOptions;
  suggestions: Suggestion[];
  client: Client;
  infoMode: boolean;
  status: 'pending' | 'true' | 'false' | 'full';
}
// ------------------------------ API ---------------------------

export interface ChatApiResponse {
  status: boolean;
  messages: ChatMessage[];
}

// ---------------------------- Message -------------------------
export class MessagesOptions {
  public fullyLoaded = false;
  public constructor(init?: Partial<MessagesOptions>) {
    Object.assign(this, init);
  }
}
export interface ChatMessage {
  author: string;
  created: string;
  intent: any;
  client_id?: string;
  message: ChatMessageBody;
  parsed: boolean;
  scores: ChatMessageScores;
  send: ChatMessageSend;
  source: ChatMessageSource;
}

export interface ChatMessageBody {
  type: string;
  content: { text?: string; url?: string; name?: string };
}

export interface ChatMessageScores {
  brand_acceptance: number;
  happy_2_buy: number;
  negative: number;
  sentiment: number;
}

export interface ChatMessageSource {
  scenario: { scenario_id: string; name: string };
  step: { id: string; name: string };
  user: { account_id: string; name: string; avatar: string };
  broadcast: { broadcast_id: string; name: string };
  intent: { intent_id: string; name: string };
  type: string;
}

export interface ChatMessageSend {
  delivered: boolean;
  read: boolean;
  pending?: boolean;
}

export interface Suggestion {
  text: string;
  type: string;
}
